import t from "react";
import { ChevronLeft as m, ChevronRight as u } from "@olxbr/ds-icons";
import { VisuallyHidden as a } from "../../../VisuallyHidden/VisuallyHidden.js";
import { useScrollVisibility as _ } from "./useScrollVisibility.js";
import { cls as s } from "../../../../helpers/cls.js";
const o = _ref => {
  let {
    children: e,
    selectedTabId: n,
    onSelectTab: i
  } = _ref;
  const r = t.Children.toArray(e),
    {
      isScrollLeftButtonVisible: b,
      isScrollRightButtonVisible: c,
      handleShiftButtonClick: l,
      tabsContentRef: d
    } = _({
      tabButtons: r,
      selectedTabId: n,
      onSelectTab: i
    });
  return t.createElement("div", {
    className: "olx-tabs__tablist",
    role: "tablist"
  }, t.createElement("button", {
    role: "tab",
    className: s("olx-tabs__tablist-button", "olx-tabs__tablist-button--left", !b && "olx-tabs__tablist-button--hidden"),
    onClick: () => l("left"),
    "data-ds-component": "DS-Tabs-Button",
    "data-testid": "ds-tabs-scroll-left"
  }, t.createElement(m, null), t.createElement(a, null, "Scroll para a esquerda")), t.createElement("div", {
    className: "olx-tabs__tablist-content",
    ref: d
  }, t.createElement("div", {
    className: "olx-tabs__tablist-buttons-wrapper"
  }, e)), t.createElement("button", {
    role: "tab",
    className: s("olx-tabs__tablist-button", "olx-tabs__tablist-button--right", !c && "olx-tabs__tablist-button--hidden"),
    onClick: () => l("right"),
    "data-ds-component": "DS-Tabs-Button",
    "data-testid": "ds-tabs-scroll-right"
  }, t.createElement(u, null), t.createElement(a, null, "Scroll para a direita")));
};
o.displayName = "Tablist";
export { o as Tablist };